/**
 * Map the source label:
 * - Contains "usgs:" → "United States Geological Survey"
 * - Contains "bgs:"  → "British Geological Survey"
 * - Otherwise → keep the raw string
 */
export function mapSourceLabel(v: unknown): string | null {
  if (v === null || v === undefined) {
    return null;
  }
  const raw = String(v).trim();
  if (!raw) {
    return null;
  }
  const lc = raw.toLowerCase();
  if (lc.includes("usgs:")) {
    return "United States Geological Survey";
  }
  if (lc.includes("bgs:")) {
    return "British Geological Survey";
  }
  return raw;
}
